export const formatPhone = (value: string, separatorSymbol = '-', withPlus = true) => {
  // strip non-digit characters before formatting
  const digits = value?.replace(/\D/g, '') ?? '';

  return `${withPlus ? '+' : ''}${digits.slice(0, 3)}${separatorSymbol}${digits.slice(
    3,
    5,
  )}${separatorSymbol}${digits.slice(5, 8)}${separatorSymbol}${digits.slice(8)}`;
};
